import { Jwt_toUserInfo, SessionManagement_SessionManagementModel__get_token, SessionManagementMsg, SessionManagement_update, SessionManagement_SessionManagementModel_token__39A60A33, InactivityConfig_create_Z5C7ECD40, SessionManagement_init } from "../Session.js";
import { Model__get_isLogoutConfirmed, MfaModel__get_MfaCode, MfaModel_get_emptyMfaCode, ResetPasswordModel, InactivityModel_get_isActive_, Model_get_inactivity_, InactivityModel_get_loggedOut, InactivityModel_get_warning, MfaModel, Msg, Model, InactivityModel_get_init, MfaModel_get_empty, ResetPasswordModel_get_empty, InactivityModel_get_timeUntilLogout, InactivityModel_get_timeUntilWarning } from "./AuthTypes.js";
import { Security_ResetPasswordViewModel, Security_ResetPasswordViewModel_get_empty, Security_LoginViewModel, Security_AuthErrorMessage_get_describe, Security_RegisterViewModel_get_empty, Security_LoginViewModel_get_empty } from "../fable_modules/Webbler.Models.1.6.0/Api.fs.js";
import { utcNow, addSeconds, minValue } from "../fable_modules/fable-library-js.4.19.3/DateOffset.js";
import { Cmd_ofEffect, Cmd_none, Cmd_map, Cmd_batch } from "../fable_modules/Fable.Elmish.4.2.0/cmd.fs.js";
import { ofArray, singleton } from "../fable_modules/fable-library-js.4.19.3/List.js";
import { Toast_successToast, Urls_Page, Urls_AuthPage, Urls_pageHash, Toast_errorToast } from "../Common/General.js";
import { some, map, defaultArg } from "../fable_modules/fable-library-js.4.19.3/Option.js";
import { isNullOrEmpty, printf, toText } from "../fable_modules/fable-library-js.4.19.3/String.js";
import { Compose_Lens, Compose_Lens_op_GreaterMinusGreater_31E453EA, Optic_Set, Optic_Set_op_HatEquals_2170E4F5 } from "../fable_modules/Fable.Aether.1.0.2/Aether.fs.js";
import { Cmd_OfAsyncWith_attempt, Cmd_OfAsync_start, Cmd_OfAsyncWith_either } from "../fable_modules/Fable.Elmish.4.2.0/cmd.fs.js";
import { mfaApi, securedAuthApi, securedUserManagementApi, publicAuthApi } from "../Api.js";
import { Navigation_newUrl } from "../fable_modules/Fable.Elmish.Browser.4.0.3/navigation.fs.js";
import { isDigit } from "../fable_modules/fable-library-js.4.19.3/Char.js";
import { setItem, copy } from "../fable_modules/fable-library-js.4.19.3/Array.js";
import { MfaChallengeError_get_describe, MfaResendRequest, MfaVerifyRequest } from "../fable_modules/Webbler.Models.1.6.0/MfaChallenge.fs.js";
import { compare } from "../fable_modules/fable-library-js.4.19.3/Date.js";

export function init() {
    const patternInput = SessionManagement_init(undefined, InactivityConfig_create_Z5C7ECD40(InactivityModel_get_timeUntilWarning(), InactivityModel_get_timeUntilLogout()));
    return [new Model(Security_LoginViewModel_get_empty(), Security_RegisterViewModel_get_empty(), ResetPasswordModel_get_empty(), undefined, patternInput[0], MfaModel_get_empty(), minValue(), InactivityModel_get_init()), Cmd_batch(ofArray([singleton((dispatch) => {
        dispatch(new Msg(7, []));
    }), Cmd_map((Item) => (new Msg(26, [Item])), patternInput[1])]))];
}

const errorToast = (() => {
    const f1 = Security_AuthErrorMessage_get_describe();
    return (arg) => Toast_errorToast(f1(arg));
})();

function maybeWithToken(f) {
    return (arg_1) => defaultArg(map(f, SessionManagement_SessionManagementModel_token__39A60A33(arg_1)), Cmd_none());
}

function startMfaCooldownInterval(mfaModel) {
    if (mfaModel.MfaCooldownTimerId == null) {
        return Cmd_ofEffect((dispatch) => {
            dispatch(new Msg(24, [window.setInterval((_arg) => {
                dispatch(new Msg(23, []));
            }, 1000)]));
        });
    }
    else {
        return Cmd_none();
    }
}

function clearMfaCooldownInterval(model) {
    const matchValue = model.MfaCooldownTimerId;
    if (matchValue == null) {
        return [model, Cmd_none()];
    }
    else {
        const id = matchValue;
        const value = window.clearInterval(id);
        return [new MfaModel(model.MfaPendingToken, model.MfaChallengeId, model.MfaCodeDigits, model.MfaExpiresAt, model.MfaCooldownSeconds, undefined, model.MfaError, model.MfaIsVerifying), Cmd_none()];
    }
}

function resetMfaState(mfaModel) {
    return [new MfaModel(mfaModel.MfaPendingToken, mfaModel.MfaChallengeId, mfaModel.MfaCodeDigits, mfaModel.MfaExpiresAt, mfaModel.MfaCooldownSeconds, undefined, mfaModel.MfaError, mfaModel.MfaIsVerifying), clearMfaCooldownInterval(mfaModel)[1]];
}

export function update(isInactivityDisabled, msg, model) {
    let l, bind$0040, bind$0040_2, bind$0040_3, bind$0040_4, pendingToken, challengeId, bind$0040_5, bind$0040_8, bind$0040_9, expiresAt_2, bind$0040_10;
    switch (msg.tag) {
        case 0: {
            console.error(some(toText(printf("Error: %O"))(msg.fields[0])));
            return [model, Cmd_none()];
        }
        case 26: {
            const patternInput = SessionManagement_update(isInactivityDisabled, msg.fields[0], model.sessionManagement);
            const patternInput_1 = (msg.fields[0].tag === 7) ? [InactivityModel_get_warning(), singleton((dispatch) => {
                dispatch(new Msg(27, [true]));
            })] : ((msg.fields[0].tag === 8) ? [InactivityModel_get_loggedOut(), singleton((dispatch_1) => {
                dispatch_1(new Msg(6, []));
            })] : [model.inactivity, Cmd_none()]);
            return [new Model(model.loginVm, model.registerVm, model.resetPasswordModel, model.userInfo, patternInput[0], model.mfaModel, model.logoutConfirmedUntil, patternInput_1[0]), Cmd_batch(ofArray([Cmd_map((Item) => (new Msg(26, [Item])), patternInput[1]), patternInput_1[1]]))];
        }
        case 27:
            return [Optic_Set_op_HatEquals_2170E4F5(new Optic_Set(), (l = Model_get_inactivity_(), Compose_Lens_op_GreaterMinusGreater_31E453EA(new Compose_Lens(), InactivityModel_get_isActive_())(l)))(msg.fields[0])(model), Cmd_none()];
        case 1:
            return [new Model(model.loginVm, msg.fields[0](model.registerVm), model.resetPasswordModel, model.userInfo, model.sessionManagement, model.mfaModel, model.logoutConfirmedUntil, model.inactivity), Cmd_none()];
        case 2:
            return [new Model(msg.fields[0](model.loginVm), model.registerVm, model.resetPasswordModel, model.userInfo, model.sessionManagement, model.mfaModel, model.logoutConfirmedUntil, model.inactivity), Cmd_none()];
        case 3:
            return [new Model(model.loginVm, model.registerVm, (bind$0040 = model.resetPasswordModel, new ResetPasswordModel(msg.fields[0](model.resetPasswordModel.resetPasswordVm), bind$0040.resetRequestEmail, bind$0040.hideResetEmail)), model.userInfo, model.sessionManagement, model.mfaModel, model.logoutConfirmedUntil, model.inactivity), Cmd_none()];
        case 4:
            return [new Model(new Security_LoginViewModel(model.loginVm.email, ""), model.registerVm, model.resetPasswordModel, model.userInfo, model.sessionManagement, model.mfaModel, model.logoutConfirmedUntil, model.inactivity), Cmd_OfAsyncWith_either((x) => {
                Cmd_OfAsync_start(x);
            }, publicAuthApi.login, model.loginVm, (Item_1) => (new Msg(5, [Item_1])), (Item_2) => (new Msg(0, [Item_2])))];
        case 5:
            if (msg.fields[0].tag === 1) {
                return [model, errorToast(msg.fields[0].fields[0])];
            }
            else {
                switch (msg.fields[0].fields[0].tag) {
                    case 1:
                        return [new Model(model.loginVm, model.registerVm, new ResetPasswordModel((bind$0040_2 = Security_ResetPasswordViewModel_get_empty(), new Security_ResetPasswordViewModel(model.loginVm.email, msg.fields[0].fields[0].fields[0], bind$0040_2.newPassword, bind$0040_2.confirmPassword)), "", true), undefined, model.sessionManagement, model.mfaModel, model.logoutConfirmedUntil, model.inactivity), Cmd_batch(ofArray([singleton((dispatch_4) => {
                            dispatch_4(new Msg(26, [new SessionManagementMsg(2, [])]));
                        }), Navigation_newUrl(Urls_pageHash(new Urls_Page(0, [new Urls_AuthPage(2, [undefined])])))]))];
                    case 2: {
                        const challenge = msg.fields[0].fields[0].fields[0];
                        const expiresAt = addSeconds(utcNow(), challenge.ExpiresInSeconds);
                        const patternInput_2 = clearMfaCooldownInterval(model.mfaModel);
                        const newModel = new Model(model.loginVm, model.registerVm, model.resetPasswordModel, model.userInfo, model.sessionManagement, new MfaModel(challenge.PendingToken, challenge.ChallengeId, MfaModel_get_emptyMfaCode(), expiresAt, challenge.CooldownSeconds, undefined, undefined, false), model.logoutConfirmedUntil, model.inactivity);
                        return [newModel, Cmd_batch(ofArray([patternInput_2[1], Navigation_newUrl(Urls_pageHash(new Urls_Page(0, [new Urls_AuthPage(1, [])]))), startMfaCooldownInterval(newModel.mfaModel)]))];
                    }
                    default:
                        return [model, Cmd_batch(ofArray([singleton((dispatch_2) => {
                            dispatch_2(new Msg(26, [new SessionManagementMsg(1, [msg.fields[0].fields[0].fields[0]])]));
                        }), singleton((dispatch_3) => {
                            dispatch_3(new Msg(7, []));
                        })]))];
                }
            }
        case 7:
            return [model, maybeWithToken((t_2) => Cmd_OfAsyncWith_either((x_1) => {
                Cmd_OfAsync_start(x_1);
            }, securedUserManagementApi(t_2).getCurrentUserData, undefined, (Item_4) => (new Msg(8, [Item_4])), (Item_5) => (new Msg(0, [Item_5]))))(model.sessionManagement)];
        case 8: {
            const matchValue = SessionManagement_SessionManagementModel__get_token(model.sessionManagement);
            let matchResult, token, userData, e_1;
            const copyOfStruct_1 = msg.fields[0];
            if (copyOfStruct_1.tag === 1) {
                if (matchValue == null) {
                    matchResult = 1;
                }
                else {
                    matchResult = 2;
                    e_1 = copyOfStruct_1.fields[0];
                }
            }
            else if (matchValue == null) {
                matchResult = 1;
            }
            else {
                matchResult = 0;
                token = matchValue;
                userData = copyOfStruct_1.fields[0];
            }
            switch (matchResult) {
                case 0: {
                    const userInfoResult = Jwt_toUserInfo(token.decoded, userData);
                    if (userInfoResult.tag === 1) {
                        return [model, Toast_errorToast("Failed to parse user info from bearer token, please log in again")];
                    }
                    else {
                        const userInfo_1 = userInfoResult.fields[0];
                        return [new Model(model.loginVm, model.registerVm, model.resetPasswordModel, userInfo_1, model.sessionManagement, model.mfaModel, model.logoutConfirmedUntil, model.inactivity), singleton((dispatch_5) => {
                            dispatch_5(new Msg(16, [userInfo_1]));
                        })];
                    }
                }
                case 1:
                    return [model, Toast_errorToast("Missing bearer token, please log in again")];
                default:
                    return [model, errorToast(e_1)];
            }
        }
        case 6:
            return [new Model(model.loginVm, model.registerVm, model.resetPasswordModel, undefined, model.sessionManagement, model.mfaModel, model.logoutConfirmedUntil, model.inactivity), Cmd_batch(ofArray([maybeWithToken((t_3) => Cmd_OfAsyncWith_either((x_2) => {
                Cmd_OfAsync_start(x_2);
            }, securedAuthApi(t_3).logout, undefined, (Item_6) => (new Msg(9, [Item_6])), (Item_7) => (new Msg(0, [Item_7]))))(model.sessionManagement), singleton((dispatch_6) => {
                dispatch_6(new Msg(26, [new SessionManagementMsg(2, [])]));
            }), Navigation_newUrl(Urls_pageHash(new Urls_Page(0, [new Urls_AuthPage(0, [])])))]))];
        case 9:
            if (msg.fields[0].tag === 1) {
                return [model, Cmd_none()];
            }
            else {
                document.location.reload();
                return [model, Cmd_none()];
            }
        case 10:
            return [model, Cmd_OfAsyncWith_either((x_3) => {
                Cmd_OfAsync_start(x_3);
            }, publicAuthApi.register, model.registerVm, (Item_8) => (new Msg(11, [Item_8])), (Item_9) => (new Msg(0, [Item_9])))];
        case 11:
            if (msg.fields[0].tag === 1) {
                return [model, errorToast(msg.fields[0].fields[0])];
            }
            else {
                return [model, Cmd_batch(ofArray([Toast_successToast("Success"), Navigation_newUrl(Urls_pageHash(new Urls_Page(0, [new Urls_AuthPage(0, [])])))]))];
            }
        case 12:
            return [model, Cmd_OfAsyncWith_either((x_4) => {
                Cmd_OfAsync_start(x_4);
            }, publicAuthApi.resetPasswordWithToken, model.resetPasswordModel.resetPasswordVm, (Item_10) => (new Msg(13, [Item_10])), (Item_11) => (new Msg(0, [Item_11])))];
        case 13:
            if (msg.fields[0].tag === 1) {
                return [model, errorToast(msg.fields[0].fields[0])];
            }
            else {
                return [model, Cmd_batch(ofArray([Toast_successToast("Success, please log in with your new password"), Navigation_newUrl(Urls_pageHash(new Urls_Page(0, [new Urls_AuthPage(0, [])])))]))];
            }
        case 14:
            return [new Model(model.loginVm, model.registerVm, (bind$0040_3 = model.resetPasswordModel, new ResetPasswordModel(bind$0040_3.resetPasswordVm, msg.fields[0], bind$0040_3.hideResetEmail)), model.userInfo, model.sessionManagement, model.mfaModel, model.logoutConfirmedUntil, model.inactivity), Cmd_none()];
        case 15:
            return [new Model(model.loginVm, model.registerVm, ResetPasswordModel_get_empty(), model.userInfo, model.sessionManagement, model.mfaModel, model.logoutConfirmedUntil, model.inactivity), Cmd_batch(ofArray([Cmd_OfAsyncWith_attempt((x_5) => {
                Cmd_OfAsync_start(x_5);
            }, publicAuthApi.requestPasswordResetTokenEmail, model.resetPasswordModel.resetRequestEmail, (Item_12) => (new Msg(0, [Item_12]))), Toast_successToast("An email has been sent to the specified address"), Navigation_newUrl(Urls_pageHash(new Urls_Page(0, [new Urls_AuthPage(0, [])])))]))];
        case 17:
            if (msg.fields[0].tag === 2) {
                return [model, singleton((dispatch_7) => {
                    dispatch_7(new Msg(7, []));
                })];
            }
            else {
                return [model, Cmd_none()];
            }
        case 18: {
            const sanitizedDigit = isNullOrEmpty(msg.fields[1]) ? "" : (((msg.fields[1].length === 1) && isDigit(msg.fields[1][0])) ? msg.fields[1] : "");
            const newDigits = copy(model.mfaModel.MfaCodeDigits);
            if ((msg.fields[0] >= 0) && (msg.fields[0] < 6)) {
                setItem(newDigits, msg.fields[0], sanitizedDigit);
            }
            return [new Model(model.loginVm, model.registerVm, model.resetPasswordModel, model.userInfo, model.sessionManagement, (bind$0040_4 = model.mfaModel, new MfaModel(bind$0040_4.MfaPendingToken, bind$0040_4.MfaChallengeId, newDigits, bind$0040_4.MfaExpiresAt, bind$0040_4.MfaCooldownSeconds, bind$0040_4.MfaCooldownTimerId, undefined, bind$0040_4.MfaIsVerifying)), model.logoutConfirmedUntil, model.inactivity), Cmd_none()];
        }
        case 19: {
            const mfaModel_1 = model.mfaModel;
            const matchValue_2 = mfaModel_1.MfaPendingToken;
            const matchValue_3 = mfaModel_1.MfaChallengeId;
            let matchResult_1, challengeId_1, pendingToken_1;
            if (matchValue_2 != null) {
                if (matchValue_3 != null) {
                    if ((pendingToken = matchValue_2, (challengeId = matchValue_3, MfaModel__get_MfaCode(mfaModel_1).length === 6))) {
                        matchResult_1 = 0;
                        challengeId_1 = matchValue_3;
                        pendingToken_1 = matchValue_2;
                    }
                    else if (MfaModel__get_MfaCode(mfaModel_1).length < 6) {
                        matchResult_1 = 1;
                    }
                    else {
                        matchResult_1 = 2;
                    }
                }
                else if (MfaModel__get_MfaCode(mfaModel_1).length < 6) {
                    matchResult_1 = 1;
                }
                else {
                    matchResult_1 = 2;
                }
            }
            else if (MfaModel__get_MfaCode(mfaModel_1).length < 6) {
                matchResult_1 = 1;
            }
            else {
                matchResult_1 = 2;
            }
            switch (matchResult_1) {
                case 0: {
                    const request = new MfaVerifyRequest(challengeId_1, MfaModel__get_MfaCode(mfaModel_1));
                    return [new Model(model.loginVm, model.registerVm, model.resetPasswordModel, model.userInfo, model.sessionManagement, new MfaModel(mfaModel_1.MfaPendingToken, mfaModel_1.MfaChallengeId, mfaModel_1.MfaCodeDigits, mfaModel_1.MfaExpiresAt, mfaModel_1.MfaCooldownSeconds, mfaModel_1.MfaCooldownTimerId, undefined, true), model.logoutConfirmedUntil, model.inactivity), Cmd_OfAsyncWith_either((x_6) => {
                        Cmd_OfAsync_start(x_6);
                    }, mfaApi(pendingToken_1).verify, request, (Item_13) => (new Msg(20, [Item_13])), (Item_14) => (new Msg(0, [Item_14])))];
                }
                case 1:
                    return [model, Toast_errorToast("Please enter all 6 digits")];
                default: {
                    const patternInput_3 = resetMfaState(model.mfaModel);
                    return [new Model(model.loginVm, model.registerVm, model.resetPasswordModel, model.userInfo, model.sessionManagement, patternInput_3[0], model.logoutConfirmedUntil, model.inactivity), Cmd_batch(ofArray([Toast_errorToast("Error occurred, please login again"), patternInput_3[1], Navigation_newUrl(Urls_pageHash(new Urls_Page(0, [new Urls_AuthPage(0, [])])))]))];
                }
            }
        }
        case 20:
            if (msg.fields[0].tag === 1) {
                if (msg.fields[0].fields[0].tag === 5) {
                    const patternInput_5 = resetMfaState(model.mfaModel);
                    return [new Model(model.loginVm, model.registerVm, model.resetPasswordModel, model.userInfo, model.sessionManagement, patternInput_5[0], model.logoutConfirmedUntil, model.inactivity), Cmd_batch(ofArray([Toast_errorToast("Error occured, please try to login again"), patternInput_5[1], Navigation_newUrl(Urls_pageHash(new Urls_Page(0, [new Urls_AuthPage(0, [])])))]))];
                }
                else {
                    return [new Model(model.loginVm, model.registerVm, model.resetPasswordModel, model.userInfo, model.sessionManagement, (bind$0040_5 = model.mfaModel, new MfaModel(bind$0040_5.MfaPendingToken, bind$0040_5.MfaChallengeId, MfaModel_get_emptyMfaCode(), bind$0040_5.MfaExpiresAt, bind$0040_5.MfaCooldownSeconds, bind$0040_5.MfaCooldownTimerId, bind$0040_5.MfaError, false)), model.logoutConfirmedUntil, model.inactivity), Toast_errorToast("Error occured, please try to login again")];
                }
            }
            else {
                const patternInput_4 = resetMfaState(model.mfaModel);
                return [new Model(model.loginVm, model.registerVm, model.resetPasswordModel, model.userInfo, model.sessionManagement, patternInput_4[0], model.logoutConfirmedUntil, model.inactivity), Cmd_batch(ofArray([patternInput_4[1], singleton((dispatch_8) => {
                    dispatch_8(new Msg(26, [new SessionManagementMsg(1, [msg.fields[0].fields[0].jwtToken])]));
                }), singleton((dispatch_9) => {
                    dispatch_9(new Msg(7, []));
                })]))];
            }
        case 21: {
            let isExpired;
            const matchValue_5 = model.mfaModel.MfaExpiresAt;
            if (matchValue_5 == null) {
                isExpired = true;
            }
            else {
                const expiresAt_1 = matchValue_5;
                isExpired = (compare(utcNow(), expiresAt_1) > 0);
            }
            const mfaModel_2 = model.mfaModel;
            const matchValue_6 = mfaModel_2.MfaPendingToken;
            const matchValue_7 = mfaModel_2.MfaChallengeId;
            let matchResult_2, challengeId_2, pendingToken_2;
            if (matchValue_6 != null) {
                if (matchValue_7 != null) {
                    if (isExpired) {
                        matchResult_2 = 1;
                    }
                    else {
                        matchResult_2 = 0;
                        challengeId_2 = matchValue_7;
                        pendingToken_2 = matchValue_6;
                    }
                }
                else {
                    matchResult_2 = 1;
                }
            }
            else {
                matchResult_2 = 1;
            }
            switch (matchResult_2) {
                case 0: {
                    const request_1 = new MfaResendRequest(challengeId_2);
                    return [model, Cmd_OfAsyncWith_either((x_7) => {
                        Cmd_OfAsync_start(x_7);
                    }, mfaApi(pendingToken_2).resend, request_1, (Item_15) => (new Msg(22, [Item_15])), (Item_16) => (new Msg(0, [Item_16])))];
                }
                default: {
                    const patternInput_6 = resetMfaState(model.mfaModel);
                    return [new Model(model.loginVm, model.registerVm, model.resetPasswordModel, model.userInfo, model.sessionManagement, patternInput_6[0], model.logoutConfirmedUntil, model.inactivity), Cmd_batch(ofArray([Toast_errorToast("Session expired, please login again"), patternInput_6[1], Navigation_newUrl(Urls_pageHash(new Urls_Page(0, [new Urls_AuthPage(0, [])])))]))];
                }
            }
        }
        case 22:
            if (msg.fields[0].tag === 1) {
                const patternInput_9 = resetMfaState(model.mfaModel);
                return [new Model(model.loginVm, model.registerVm, model.resetPasswordModel, model.userInfo, model.sessionManagement, patternInput_9[0], model.logoutConfirmedUntil, model.inactivity), Cmd_batch(ofArray([patternInput_9[1], Toast_errorToast(MfaChallengeError_get_describe()(msg.fields[0].fields[0])), Navigation_newUrl(Urls_pageHash(new Urls_Page(0, [new Urls_AuthPage(0, [])])))]))];
            }
            else {
                const response = msg.fields[0].fields[0];
                if (response.Sent) {
                    const matchValue_9 = response.CooldownSeconds;
                    if (matchValue_9 == null) {
                        const patternInput_7 = clearMfaCooldownInterval(model.mfaModel);
                        const clearedMfaModel_1 = patternInput_7[0];
                        return [new Model(model.loginVm, model.registerVm, model.resetPasswordModel, model.userInfo, model.sessionManagement, new MfaModel(clearedMfaModel_1.MfaPendingToken, clearedMfaModel_1.MfaChallengeId, clearedMfaModel_1.MfaCodeDigits, clearedMfaModel_1.MfaExpiresAt, undefined, clearedMfaModel_1.MfaCooldownTimerId, clearedMfaModel_1.MfaError, clearedMfaModel_1.MfaIsVerifying), model.logoutConfirmedUntil, model.inactivity), Cmd_batch(ofArray([patternInput_7[1], Toast_successToast("A new code has been sent to your email")]))];
                    }
                    else {
                        let newMfa;
                        const bind$0040_6 = model.mfaModel;
                        newMfa = (new MfaModel(bind$0040_6.MfaPendingToken, bind$0040_6.MfaChallengeId, bind$0040_6.MfaCodeDigits, response.ExpiresAt, matchValue_9, bind$0040_6.MfaCooldownTimerId, bind$0040_6.MfaError, bind$0040_6.MfaIsVerifying));
                        return [new Model(model.loginVm, model.registerVm, model.resetPasswordModel, model.userInfo, model.sessionManagement, newMfa, model.logoutConfirmedUntil, model.inactivity), Cmd_batch(ofArray([Toast_successToast("A new code has been sent to your email"), startMfaCooldownInterval(newMfa)]))];
                    }
                }
                else {
                    const matchValue_10 = response.CooldownSeconds;
                    if (matchValue_10 == null) {
                        const patternInput_8 = clearMfaCooldownInterval(model.mfaModel);
                        const clearedMfaModel_2 = patternInput_8[0];
                        return [new Model(model.loginVm, model.registerVm, model.resetPasswordModel, model.userInfo, model.sessionManagement, new MfaModel(clearedMfaModel_2.MfaPendingToken, clearedMfaModel_2.MfaChallengeId, clearedMfaModel_2.MfaCodeDigits, clearedMfaModel_2.MfaExpiresAt, undefined, clearedMfaModel_2.MfaCooldownTimerId, clearedMfaModel_2.MfaError, clearedMfaModel_2.MfaIsVerifying), model.logoutConfirmedUntil, model.inactivity), patternInput_8[1]];
                    }
                    else {
                        let newMfaModel_1;
                        const bind$0040_7 = model.mfaModel;
                        newMfaModel_1 = (new MfaModel(bind$0040_7.MfaPendingToken, bind$0040_7.MfaChallengeId, bind$0040_7.MfaCodeDigits, bind$0040_7.MfaExpiresAt, matchValue_10, bind$0040_7.MfaCooldownTimerId, bind$0040_7.MfaError, bind$0040_7.MfaIsVerifying));
                        return [new Model(model.loginVm, model.registerVm, model.resetPasswordModel, model.userInfo, model.sessionManagement, newMfaModel_1, model.logoutConfirmedUntil, model.inactivity), startMfaCooldownInterval(newMfaModel_1)];
                    }
                }
            }
        case 23: {
            const matchValue_11 = model.mfaModel.MfaExpiresAt;
            let matchResult_3, expiresAt_3;
            if (matchValue_11 != null) {
                if ((expiresAt_2 = matchValue_11, compare(utcNow(), expiresAt_2) > 0)) {
                    matchResult_3 = 0;
                    expiresAt_3 = matchValue_11;
                }
                else {
                    matchResult_3 = 1;
                }
            }
            else {
                matchResult_3 = 1;
            }
            switch (matchResult_3) {
                case 0: {
                    const patternInput_10 = resetMfaState(model.mfaModel);
                    return [new Model(model.loginVm, model.registerVm, model.resetPasswordModel, model.userInfo, model.sessionManagement, patternInput_10[0], model.logoutConfirmedUntil, model.inactivity), Cmd_batch(ofArray([Toast_errorToast("Session expired, please login again"), patternInput_10[1], Navigation_newUrl(Urls_pageHash(new Urls_Page(0, [new Urls_AuthPage(0, [])])))]))];
                }
                default: {
                    const matchValue_12 = model.mfaModel.MfaCooldownSeconds;
                    if (matchValue_12 == null) {
                        return [model, Cmd_none()];
                    }
                    else if (matchValue_12 > 1) {
                        const s_2 = matchValue_12 | 0;
                        return [new Model(model.loginVm, model.registerVm, model.resetPasswordModel, model.userInfo, model.sessionManagement, (bind$0040_8 = model.mfaModel, new MfaModel(bind$0040_8.MfaPendingToken, bind$0040_8.MfaChallengeId, bind$0040_8.MfaCodeDigits, bind$0040_8.MfaExpiresAt, s_2 - 1, bind$0040_8.MfaCooldownTimerId, bind$0040_8.MfaError, bind$0040_8.MfaIsVerifying)), model.logoutConfirmedUntil, model.inactivity), Cmd_none()];
                    }
                    else {
                        return [new Model(model.loginVm, model.registerVm, model.resetPasswordModel, model.userInfo, model.sessionManagement, (bind$0040_9 = model.mfaModel, new MfaModel(bind$0040_9.MfaPendingToken, bind$0040_9.MfaChallengeId, bind$0040_9.MfaCodeDigits, bind$0040_9.MfaExpiresAt, undefined, bind$0040_9.MfaCooldownTimerId, bind$0040_9.MfaError, bind$0040_9.MfaIsVerifying)), model.logoutConfirmedUntil, model.inactivity), Cmd_none()];
                    }
                }
            }
        }
        case 24:
            return [new Model(model.loginVm, model.registerVm, model.resetPasswordModel, model.userInfo, model.sessionManagement, (bind$0040_10 = model.mfaModel, new MfaModel(bind$0040_10.MfaPendingToken, bind$0040_10.MfaChallengeId, bind$0040_10.MfaCodeDigits, bind$0040_10.MfaExpiresAt, bind$0040_10.MfaCooldownSeconds, msg.fields[0], bind$0040_10.MfaError, bind$0040_10.MfaIsVerifying)), model.logoutConfirmedUntil, model.inactivity), Cmd_none()];
        case 25: {
            const patternInput_11 = resetMfaState(model.mfaModel);
            return [new Model(model.loginVm, model.registerVm, model.resetPasswordModel, model.userInfo, model.sessionManagement, patternInput_11[0], model.logoutConfirmedUntil, model.inactivity), patternInput_11[1]];
        }
        case 28:
            if (!Model__get_isLogoutConfirmed(model)) {
                return [new Model(model.loginVm, model.registerVm, model.resetPasswordModel, model.userInfo, model.sessionManagement, model.mfaModel, addSeconds(utcNow(), 10), model.inactivity), Toast_errorToast("You have unsaved changes, please save any work or click log out again to discard and log out")];
            }
            else {
                return [new Model(model.loginVm, model.registerVm, model.resetPasswordModel, model.userInfo, model.sessionManagement, model.mfaModel, minValue(), model.inactivity), singleton((dispatch_10) => {
                    dispatch_10(new Msg(6, []));
                })];
            }
        default:
            return [model, Cmd_none()];
    }
}

